import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/comisionCoordinadorAdministrativo";
import { GetComisionesPorPeriodo } from "../../../reducers/comisionCoordinadorAdministrativo";

export interface ReporteCoordinadorAdministrativoDispatcher {
  getComisionesPorPeriodo: (
    periodo: string
  ) => Promise<Preview<GetComisionesPorPeriodo>>;
}

export const reporteCoordinadorAdministrativoDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ReporteCoordinadorAdministrativoDispatcher = dispatch => ({
  getComisionesPorPeriodo: (periodo: string) => {
    return dispatch(actions.getComisionesPorPeriodo(periodo));
  }
});
